import PropTypes from 'prop-types';
import { keys, noop } from 'lodash';
// Import Components
import { CustomerJourneyVisualizationTemplate } from 'components/CustomerJourneyVisualization';

const CustomerJourneyVisualizationTemplateGroup = ({
    templates,
    onChange,
    withDescription,
    namePlaceholder,
    nameValidationSchema,
}) => {
    const templateChangeHandlerCreator = (templateKey) => {
        return (data) => {
            onChange(templateKey, data);
        };
    };

    return (
        <div className="cj-visual-info-wrapper">
            {keys(templates).map((templateKey, index) => {
                return (
                    <div className="cj-visual-info-row" key={index}>
                        <CustomerJourneyVisualizationTemplate
                            key={`${index}_${templateKey}`}
                            value={templates[templateKey]}
                            onChange={templateChangeHandlerCreator(templateKey)}
                            withDescription={withDescription}
                            namePlaceholder={namePlaceholder}
                            nameValidationSchema={nameValidationSchema}
                        />
                    </div>
                );
            })}
        </div>
    );
};

CustomerJourneyVisualizationTemplateGroup.propTypes = {
    templates: PropTypes.object,
    onChange: PropTypes.func,
    withDescription: PropTypes.bool,
    namePlaceholder: PropTypes.string,
    nameValidationSchema: PropTypes.func,
};

CustomerJourneyVisualizationTemplateGroup.defaultProps = {
    onChange: noop,
    withDescription: true,
    namePlaceholder: undefined,
    nameValidationSchema: undefined,
};

export default CustomerJourneyVisualizationTemplateGroup;
